import React from 'react';
import ControlMaps from './controls';
import FormSupplementContainer from './FormSupplementContainer';

import getControlGroups from './utils/getControlGroups';
import getSupplementalQuestions from './utils/getSupplementalQuestions';
import classNames from 'classnames';
import { isEmpty, isEqual } from 'lodash';

class FormItemContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visibleSupplementQuestions: [],
            hideQuestions: [],
        };
        this.initialValues = this.props.initialValues;
        this.initialParams = this.props.initialParams;

        this.handleSupplementTrigger = this.handleSupplementTrigger.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleRelationChange = this.handleRelationChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { requiredFields } = this.props;
        if (
            requiredFields &&
            requiredFields.length &&
            (!isEqual(prevProps.requiredFields, this.props.requiredFields) ||
                this.props.scrollToRequiredFields === true)
        ) {
            let collections = document.getElementById(requiredFields[0].name)
                || document.getElementsByClassName(requiredFields[0].name);
            collections = collections.length ? collections[0] : collections;
            const row = collections && collections.closest && collections.closest('.row');
            row && row.focus && row.focus();
            row && row.scrollIntoView && row.scrollIntoView();
            if (this.props.handleSetScrollToRequired !== undefined) {
                this.props.handleSetScrollToRequired(false);
            }
        }
        if (this.props.clearThirdLevelSuppQues &&
            this.props.clearThirdLevelSuppQues.length > 0) {
            this.props.clearThirdLevelSuppQues.map(ques => {
                if (this.state.visibleSupplementQuestions && this.state.visibleSupplementQuestions.length > 0 && this.state.visibleSupplementQuestions.includes(ques)) {
                    this.handleSupplementTrigger([]);
                }
                if (this.props.data.questionId === ques && this.props.data.hideKey && this.props.selectedRelations
                    && this.props.selectedRelations[this.props.data.hideKey]) {
                   this.handleRelationChange('', this.props.data.hideKey)
                }
            })
        }
    }

    handleSupplementTrigger(supplementalQuestionsIds, option = '') {

        if (this.props.data.thirdLevelSupplementQuesId && supplementalQuestionsIds.length < 1) {
            this.props.handleSupplementaryHide(this.props.data.thirdLevelSupplementQuesId, 'ADD');
        } else if (this.props.data.thirdLevelSupplementQuesId && this.props.clearThirdLevelSuppQues && this.props.clearThirdLevelSuppQues.length > 0 && supplementalQuestionsIds.length > 0) {
            const _supQues = [];
            this.props.data.thirdLevelSupplementQuesId.map(supQues => {
                if (this.props.clearThirdLevelSuppQues.indexOf(supQues) !== -1) {
                    _supQues.push(supQues);
                }
            })
            this.props.handleSupplementaryHide(_supQues, 'REMOVE');
        }
        this.setState({
            visibleSupplementQuestions: supplementalQuestionsIds
        });
    }

    handleFormChange() {
        this.props.handleFormChange();
    }

    async handleRelationChange(value, AI, qn) {

        await this.props.handleRelationChange(value, AI);
        let ind;
        let hideQuestions = this.state.hideQuestions;

         if (this.props.selectedRelations[AI] !== 'Other') {
             hideQuestions.push('Relation'+AI.slice(-1))
         } else {
             ind = hideQuestions.indexOf();
             hideQuestions = hideQuestions.filter(k => k!=='Relation'+AI.slice(-1));
         }

         if (!isEmpty(this.props.selectedRelations) && this.props.selectedRelations[AI] !== 'Lender/Mortgagee') {
             hideQuestions.push(AI);
         } else {
             ind = hideQuestions.indexOf(AI);
             hideQuestions = hideQuestions.filter(k => k!==AI);
         }

        await this.setState({
            hideQuestions,
        })
    }

    render() {
        const Control =
            ControlMaps[this.props.data.inputType] || ControlMaps[this.props.data.inputFormat];
        const formItemSupplementQuestions = getSupplementalQuestions(
            this.props.data,
            this.props.supplementalQuestions
        );

        const controlGroups = getControlGroups(formItemSupplementQuestions || []);
        const result = [];

        let indexBuilder = 0;
        for (const group in controlGroups) {
            const formSupplementContainer = formItemSupplementQuestions.map((item, index) => {
                let hidden = this.state.visibleSupplementQuestions && this.state.visibleSupplementQuestions.indexOf(item.questionId) === -1;
                hidden = (!!item.hideKey && this.state.hideQuestions.includes(item.hideKey)
                || (this.props.noSupplementTrigger.length > 0
                    && this.props.noSupplementTrigger.includes(item.name))
                ) ? true : hidden;
                if (this.props.hidden) {
                    hidden=this.props.hidden;
                }
                return (
                    <FormItemContainer
                        hidden={hidden}
                        key={index}
                        data={item}
                        supplementalQuestions={this.props.supplementalQuestions}
                        supplementalForm={true}
                        validation={this.props.validation}
                        initialValues={this.initialValues}
                        initialParams={this.initialParams}
                        handleFormChange={this.props.handleFormChange}
                        isUnderwriter = {this.props.isUnderwriter}
                        authStates = {this.props.authStates}
                        isSameAddress = {this.props.isSameAddress}
                        clearThirdLevelSuppQues = {this.props.clearThirdLevelSuppQues}
                        handleAddressChange={this.props.handleAddressChange}
                        addressValues={this.props.addressValues}
                        selectedRelations={this.props.selectedRelations}
                        noSupplementTrigger={this.props.noSupplementTrigger}
                        handleRelationChange={this.handleRelationChange}
                        handleOtherFieldChange={this.props.handleOtherFieldChange}
                        handleDisableFieldChange={this.props.handleDisableFieldChange}
                        requiredFields={this.props.requiredFields}
                        scrollToRequiredFields={this.props.scrollToRequiredFields}
                        handleSetScrollToRequired={this.props.handleSetScrollToRequired}
                        handleSupplementaryHide={this.props.handleSupplementaryHide}
                    />
                );
            });

            indexBuilder += 1;

            result.push(<div key={indexBuilder}>{formSupplementContainer}</div>);
        }

        const hidden_ = this.props.hidden ? 'hidden' : null;
        const additionalCity = ['additionalInsuredCity', 'thirdAdditionalInsuredCity', 'secondAdditionalInsuredCity'];
        const additionalState=['additionalInsuredState', 'secondAdditionalInsuredState', 'thirdAdditionalInsuredState'];
        const additionalZip = ['additionalInsuredZipCode', 'secondAdditionalInsuredZipCode', 'thirdAdditionalInsuredZipCode'];
        const bankForm = ['bankListForms'];
        const innerBorder = ['16_', '20_', '17_', '19_', '7_a_', '18_', '14_', '21_'];
        const removeBorderBool = this.props.data.questionId.toString().includes("supplemental")?
            innerBorder.includes(this.props.data.questionId.split('supplemental')[0]) :false;
        const floatLeft = this.props.data.questionId.toString().includes("supplemental")?
            ['21_', '18_', '14_'].includes(this.props.data.questionId.split('supplemental')[0])
            || (this.props.data.name.includes('Mortgagees') && hidden_!==null): false;
        const { requiredFields } = this.props;
        const requiredLabels = Array.isArray(requiredFields) && requiredFields.length ?
             this.props.requiredFields.map(i => i.name) : []
        const requiredLabel = requiredLabels.indexOf(this.props.data.name) > -1

        return (
            <div className={classNames(
                "row",
                {AdditionalInsuredAddress: additionalCity.includes(this.props.data.name) || additionalState.includes(this.props.data.name)},
                {AdditionalInsuredAddressZip: additionalZip.includes(this.props.data.name) },
                {moveLeft: this.props.initialValues.type === 'oi' && floatLeft && this.props.hidden === false},
                {adjustLeftPadding: this.props.data.name.includes('additionalInsuredForms')}

            )}>
                <div className={classNames("col-md-5", {supplementalContainer: this.props.hidden === false && this.props.data.name.includes('additionalInsuredForms')})}>
                    <div
                        className={classNames(
                            hidden_,
                            { required: this.props.data.required },
                            { supplementalContainer: this.props.supplementalForm && !this.props.data.name.includes('additionalInsuredForms')},
                            { removeBorder: this.props.initialValues.type === 'oi' && (removeBorderBool ||
                                bankForm.includes(this.props.data.name) || additionalState.includes(this.props.data.name)||this.props.data.name.includes('structuralWork') || additionalZip.includes(this.props.data.name))},
                            { roleOther: ['additionalInsuredRelationship'].includes(this.props.data.name)},
                        )}
                    >
                        <Control
                            hidden={this.props.hidden}
                            data={this.props.data}
                            required={this.props.data.required}
                            supplementalQuestions={this.props.supplementalQuestions}
                            handleSupplementTrigger={this.handleSupplementTrigger}
                            handleFormChange={this.handleFormChange}
                            validation={this.props.validation}
                            initialParams={this.initialParams}
                            initialValues={this.initialValues}
                            isUnderwriter = {this.props.isUnderwriter}
                            authStates = {this.props.authStates}
                            handleAddressChange={this.props.handleAddressChange}
                            addressValues={this.props.addressValues}
                            isSameAddress = {this.props.isSameAddress}
                            selectedRelations={this.props.selectedRelations}
                            noSupplementTrigger={this.props.noSupplementTrigger}
                            handleRelationChange={this.handleRelationChange}
                            handleOtherFieldChange={this.props.handleOtherFieldChange}
                            handleDisableFieldChange={this.props.handleDisableFieldChange}
                            disableOtherField={!!this.props.disableOtherField && this.props.disableOtherField.includes(this.props.data.name)}
                            requiredLabel={requiredLabel}
                        />
                        {result}
                    </div>
                </div>
            </div>
        );
    }
}

export default FormItemContainer;
